export default "/_next/static/6233639695961b95a366f22828847dce.png";